import React from 'react';

// Generic HOC to inject extra props (like check, title, etc.)
export function LogicQualitySingleCheckWrapper<P extends object, Extra extends Partial<P>>(
    WrappedComponent: React.ComponentType<P>,
    extraProps: Extra,
) {
    // omit the injected props so the outside world doesn't need to pass them
    type PropsWithoutInjected = Omit<P, keyof Extra>;

    return (props: PropsWithoutInjected) => {
        return (
            <WrappedComponent
                {...(props as P)}
                {...extraProps} // inject values (check, title, etc.)
            />
        );
    };
}
